<template>
  <o-view>
    <o-nav-bar title="Trein" :has-back-button="true" />
    <o-map />
    <o-block-list title="Kies een product">
      <o-list-item
        icon="brands/nmbs"
        iconStyle="logo"
        label="NMBS - 1ste en 2de klas"
        link="/sales/train/nmbs"
      />
      <o-list-item
        icon="brands/nmbs"
        iconStyle="logo"
        label="Trajectabonnement opvragen"
      />
      <o-list-item
        icon="brands/nmbs"
        iconStyle="logo"
        label="Railpas 1ste klas"
      />
      <o-list-item
        icon="brands/nmbs"
        iconStyle="logo"
        label="Railpas 2de klas"
      />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'

export default {
  name: 'Train',
  components: {
    OMap
  }
}
</script>
